/**
 * Formats service category names for display
 * @param {string} category - The category name (oem, recommended, optional)
 * @returns {string} - The formatted category name (OEM, Recommended, Optional)
 */
export const formatCategoryName = (category) => {
  if (!category) return "N/A";

  const categoryMap = {
    oem: "OEM",
    recommended: "Recommended",
    optional: "Optional",
  };

  return categoryMap[category?.toLowerCase()] || category;
};
